import noop from 'utils/noop';
import { Button } from 'ui/button';
import { Actions } from '../Footer.styles';
import { PublishButton, TestWorkflowButton } from './WorkflowValidationButton';
import { LastSavedText } from './LastSavedText';

interface DraftActionsProps {
  canDraftMessaging: boolean;
  canManageMessaging: boolean;
  hasPublished: boolean;
  isSaving: boolean;
  onPublishExistingWorkflow: () => void;
  onPublishNewWorkflow: () => void;
  onSaveDraft: () => void;
  onSendTestTrigger: () => void;
  updatedAt: string;
}

export const DRAFT_ACTIONS_TEST_ID = 'action-bar-draft-mode';
export const SAVE_TEST_ID = 'action-bar-save';

export const DraftActions = ({
  canManageMessaging = false,
  onSendTestTrigger = noop,
  canDraftMessaging = false,
  hasPublished,
  isSaving,
  onSaveDraft = noop,
  onPublishNewWorkflow = noop,
  onPublishExistingWorkflow = noop,
  updatedAt,
}: DraftActionsProps) => {
  return (
    <Actions data-test={DRAFT_ACTIONS_TEST_ID}>
      <LastSavedText timestamp={updatedAt} />
      <TestWorkflowButton handleTestWorkflow={onSendTestTrigger} isDisabled={!canDraftMessaging} />
      <PublishButton
        handlePublish={hasPublished ? onPublishExistingWorkflow : onPublishNewWorkflow}
        isDisabled={!canManageMessaging}
      />
      <Button
        data-test={SAVE_TEST_ID}
        isDisabled={!canDraftMessaging || isSaving}
        onClick={onSaveDraft}
      >
        {isSaving ? 'Saving...' : 'Save draft'}
      </Button>
    </Actions>
  );
};
